import { render, staticRenderFns } from "./PackagesContent.vue?vue&type=template&id=00526397&scoped=true"
import script from "./PackagesContent.vue?vue&type=script&lang=js"
export * from "./PackagesContent.vue?vue&type=script&lang=js"
import style0 from "./PackagesContent.vue?vue&type=style&index=0&id=00526397&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00526397",
  null
  
)

export default component.exports